<template>
  <div>
    <el-upload     class="image-upload"
        :file-list="choiceImages"
        action="#"
        :limit="maxSize"
        with-credentials
        :multiple="maxSize > 0"
        :data="uploadParams"
        list-type="picture-card"
        :before-upload="beforeUpload"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
            <span v-if="!disabled" @click="handlePictureCardPreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="!disabled" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span>
            <span v-if="!disabled" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import {upLoadImage} from "../../../api/utils/uploadFile";

export default {
  name: "ImageUpload",
  props: {
    placeholder: {
      type: String,
      default: '请选择图片',
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    enableZip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      choiceImages:[],
      disabled: false,
      uploadParams: {},
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  methods: {
    // 覆盖默认的上传行为
    requestUpload() {

    },
    beforeUpload(file) {
      let uid = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
      const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
      if (alows.indexOf(file.type) === -1) {
        this.$message.warning('存在不支持的图片格式');
      } else if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`);
      } else {
        const data = new FormData()
        data.append('multipartFile',file)
        upLoadImage(data).then(res => {
          if (res.data) {
            let item = {name: file.name, url: res.data,status: 'success',uid:uid};
            this.choiceImages.push(item);
            this.$emit('choiceImages', this.choiceImages);
          }
        });
        return true;
      }
      return false;
    },
    handleRemove(file) {
      const newList = this.choiceImages.filter(item => item.url !== file.url);
      this.choiceImages = newList;
      this.$emit('choiceImages', this.choiceImages);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      let url = file.url;
      window.URL = window.URL || window.webkitURL;
      var name = url.substring(url.lastIndexOf("/") + 1, url.length);
      var xhr = new XMLHttpRequest();
      var a = document.createElement("a");
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        var file = new Blob([xhr.response], { type: "application/octet-stream" });
        a.href = window.URL.createObjectURL(file);
        a.download = name;
        a.click();
      };
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
.image-upload {
  /deep/ .el-upload--picture-card {
    width: 72px;
    height: 72px;
    line-height: 78px;
  }

  /deep/ .el-upload-list__item {
    width: 72px;
    height: 72px;
  }
}

.design {
  i {
    padding: 10px;
    font-size: xx-large;
    background: white;
    border: 1px dashed #8c8c8c;
  }
}
/deep/ .el-upload--picture-card {
  width: 72px;
  height: 72px;
  line-height: 78px;
}
/deep/ .el-upload-list__item {
  width: 72px;
  height: 72px;
  .el-upload-list__item-actions {
    & > span + span {
      margin: 1px;
    }
  }
}
</style>